import classNames from 'classnames';
var Instruction = function (_a) {
    var instruction = _a.instruction, className = _a.className;
    return <div className={classNames('mb-2.5 text-xs text-gray-700', className)}>{instruction}</div>;
};
export default Instruction;
